<template>
  <Transition name="fade" mode="out-in">
    <div
      v-if="display"
      class="bandProfileEditConfirmWrapper"
      data-test-id="bandProfileEditConfirmation"
    >
      <i class="fa-solid fa-circle-info tw-mr-2 tw-block tw-text-xl" />
      <div class="text">
        {{ $t('band.profile.slug.edit.confirm00') }}
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'

const display = ref(false)

const route = useRoute()
const router = useRouter()
const localePath = useLocalePath()

onMounted(() => {
  if (route.query.confirm) {
    display.value = true
    router.replace(localePath({ query: {} }))
    window.setTimeout(() => {
      display.value = false
    }, 3300)
  }
})
</script>

<style scoped type="text/css">
.bandProfileEditConfirmWrapper {
  position: absolute;
  top: var(--navbarHeight);
  left: 0;
  width: 100%;
  padding: 16px 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(
    to bottom right,
    var(--color-param),
    var(--color-dark-param)
  );
  color: var(--color-white);
  z-index: 4;
}

.text {
  font-size: 18px;
  font-weight: 600;
}
</style>
